import { ConfirmRequest } from "@/models/api/ConfirmRequest";
import { ConfirmResponse } from "@/models/api/ConfirmResponse";
import { BookingDataTypeEnum } from "@/models/enums";
import { ConfirmResult } from "@/models/www/ConfirmResult";
import baseApi from "./api.service";

const bookService = {
	book(identifiers: string[], types: BookingDataTypeEnum[]): Promise<void> {
		return baseApi.post<void>("book", { identifiers: identifiers, types: types })
	},
	confirm(req: ConfirmRequest): Promise<ConfirmResult> {
		return new Promise((resolve, reject) => {
			baseApi.post<ConfirmResponse>("confirm", req)
			.then(resp => resolve(new ConfirmResult(resp)))
			.catch(err => reject(err));
		});
	}
}

export default bookService;